"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarrantyService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class WarrantyService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.warrantyUrl = '/rest-api/account/sub/warranty/extended/v1/details';
    }
    getWarrantyDetails() {
        return this.get(this.warrantyUrl).pipe(operators_1.map((data) => data));
    }
}
exports.WarrantyService = WarrantyService;
//# sourceMappingURL=warranty.service.js.map